<template>
  <div class="d-flex vh-100 align-items-center justify-content-center">
    <button
      type="button"
      class="btn line-push"
      @click="goToOa"
    >
      返回 LINE 官方帳號 »
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "LineOaButton",
  computed: {
    ...mapGetters("liffGeneral", ["liffOaId"]),
  },
  methods: {
    goToOa() {
      window.location.href = `https://line.me/R/ti/p/@${this.liffOaId}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.line-push {
  padding: .4rem 1rem;
  background-color: #2ba039;
  color: white;
  height: 40px;
}
</style>
